let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("foT6i"), load("6wr18"), load("ffEVr"), load("aFS1j"), load("gLGsg"), load("2YlyO")]).then(() => parcelRequire('753aK'));